// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReceiptDebug_page__6ub\\+a {
  display: flex;
  justify-content: center;
}

.ReceiptDebug_card__pgFfV {
  width: 100%;
  max-width: 1100px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 14px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.ReceiptDebug_loading__gCU3L {
  color: #64748b;
  font-size: 14px;
}

/* HEADER */
.ReceiptDebug_top__A-ukG {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.ReceiptDebug_top__A-ukG h3 {
  margin: 0;
  font-size: 0.95rem;
}

.ReceiptDebug_top__A-ukG p {
  margin: 0;
  font-size: 0.75rem;
  color: #64748b;
}

/* META */
.ReceiptDebug_metaGrid__jIYOx {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  font-size: 0.8rem;
}

.ReceiptDebug_metaGrid__jIYOx span {
  display: block;
  font-size: 0.7rem;
  color: #64748b;
}

/* PRODUCTS */
.ReceiptDebug_products__8fS69 {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ReceiptDebug_product__B8eM2 {
  border-top: 1px dashed #e2e8f0;
  padding-top: 8px;
}

.ReceiptDebug_productHeader__0ctw1 {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
}

/* MARKS */
.ReceiptDebug_marks__hcbG4 {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.ReceiptDebug_mark__ErE6p {
  background: #f1f5f9;
  border-radius: 999px;
  padding: 2px 6px;
  font-size: 0.7rem;
}

.ReceiptDebug_mark__ErE6p button {
  margin-left: 4px;
  border: none;
  background: none;
  cursor: pointer;
}

.ReceiptDebug_muted__zcIXC {
  color: #64748b;
  font-size: 0.7rem;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/Debug/ReceiptDebug.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".page {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.card {\r\n  width: 100%;\r\n  max-width: 1100px;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  border: 1px solid #e2e8f0;\r\n  padding: 14px;\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.loading {\r\n  color: #64748b;\r\n  font-size: 14px;\r\n}\r\n\r\n/* HEADER */\r\n.top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n\r\n.top h3 {\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.top p {\r\n  margin: 0;\r\n  font-size: 0.75rem;\r\n  color: #64748b;\r\n}\r\n\r\n/* META */\r\n.metaGrid {\r\n  margin-top: 10px;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 8px;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.metaGrid span {\r\n  display: block;\r\n  font-size: 0.7rem;\r\n  color: #64748b;\r\n}\r\n\r\n/* PRODUCTS */\r\n.products {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.product {\r\n  border-top: 1px dashed #e2e8f0;\r\n  padding-top: 8px;\r\n}\r\n\r\n.productHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n/* MARKS */\r\n.marks {\r\n  margin-top: 6px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.mark {\r\n  background: #f1f5f9;\r\n  border-radius: 999px;\r\n  padding: 2px 6px;\r\n  font-size: 0.7rem;\r\n}\r\n\r\n.mark button {\r\n  margin-left: 4px;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.muted {\r\n  color: #64748b;\r\n  font-size: 0.7rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ReceiptDebug_page__6ub+a`,
	"card": `ReceiptDebug_card__pgFfV`,
	"loading": `ReceiptDebug_loading__gCU3L`,
	"top": `ReceiptDebug_top__A-ukG`,
	"metaGrid": `ReceiptDebug_metaGrid__jIYOx`,
	"products": `ReceiptDebug_products__8fS69`,
	"product": `ReceiptDebug_product__B8eM2`,
	"productHeader": `ReceiptDebug_productHeader__0ctw1`,
	"marks": `ReceiptDebug_marks__hcbG4`,
	"mark": `ReceiptDebug_mark__ErE6p`,
	"muted": `ReceiptDebug_muted__zcIXC`
};
export default ___CSS_LOADER_EXPORT___;
